import { createAction, props } from '@ngrx/store';
import { EmploymentHistoryModel } from '@shared/data-access/models';

export const getList = createAction(
  '[Employment History] GET LIST',
  props<{payload:EmploymentHistoryModel[]}>()
);
